"use client";
import { DialogBackdrop } from "./DialogBackdrop.js";
import { DialogBody } from "./DialogBody.js";
import { DialogClose } from "./DialogClose.js";
import { DialogDescription } from "./DialogDescription.js";
import { DialogPopup } from "./DialogPopup.js";
import { DialogPortal } from "./DialogPortal.js";
import { DialogRoot } from "./DialogRoot.js";
import { DialogTitle } from "./DialogTitle.js";
import { DialogTrigger } from "./DialogTrigger.js";
const Dialog = {
    Root: DialogRoot,
    Trigger: DialogTrigger,
    Portal: DialogPortal,
    Backdrop: DialogBackdrop,
    Popup: DialogPopup,
    Body: DialogBody,
    Title: DialogTitle,
    Description: DialogDescription,
    Close: DialogClose
};
export { Dialog };
